import { render, staticRenderFns } from "./data1.vue?vue&type=template&id=7db8aba2&scoped=true&"
import script from "./data1.vue?vue&type=script&lang=js&"
export * from "./data1.vue?vue&type=script&lang=js&"
import style1 from "./data1.vue?vue&type=style&index=1&id=7db8aba2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db8aba2",
  null
  
)

export default component.exports